import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Service Details');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading 
        title='Service Details'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={params.serviceDetailsId}
      />
      <Spacing lg='145' md='80'/>
      <Div className="container">
        <SectionHeading 
          title='Our Creative Process' 
          subtitle='Where Ideas Take Shape' 
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45'/>
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='Discovery & Conceptualization'
              subtitle='We start by understanding your vision, goals, and audience. Through detailed discussions, we gather insights that allow us to tailor our approach and craft a custom strategy for your project.'
            />
            <Spacing lg='30' md='30'/>
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Creative Development & Design'
              subtitle='Our team brings ideas to life through design, ensuring every element aligns with your brand. Whether it is video editing, motion graphics, or brand design, we deliver visually stunning and impactful solutions.'
            />
            <Spacing lg='30' md='30'/>
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title=' Review, Refinement & Finalization'
              subtitle='Once the designs are ready, we collaborate with you to ensure everything meets your expectations. We welcome your feedback and make any necessary adjustments to perfect the final product.'
            />
            <Spacing lg='30' md='30'/>
          </Div>
        </Div>
      </Div>
      <Spacing lg='120' md='50'/>
      <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-radius_15 cs-shine_hover_1">
              <img src="/images/servicedetail1.JPG" alt="Service" className='cs-radius_15 w-100' />
            </Div>
            <Spacing lg='0' md='40'/>
          </Div>
          <Div className="col-lg-6 offset-xl-1">
            <h2 className="cs-font_50 cs-m0">Below our most design related services</h2>
            <Spacing lg='50' md='30'/>
            <Div className="row">
              <Div className="col-lg-6">
                <Button btnLink='/service/service-details' btnText='Social Media Reels & Shorts' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Brand Films' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='YouTube Videos' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Online Courses & E-learning' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Corporate Videos' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Educational Content' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Logo Design' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                
                <Button btnLink='/service/service-details' btnText='Brand Guidelines' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                
                <Button btnLink='/service/service-details' btnText='Video Branding Assets' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Typography & Color Systems' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
<Button btnLink='/service/service-details' btnText='Content Planning' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                

              </Div>
              <Div className="col-lg-6">
                <Button btnLink='/service/service-details' btnText='Events' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Non-Profit Films' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Digital Out-of-Home (DOOH) Ads' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='2D & 3D Animation' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Logo Animation' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnLink='/service/service-details' btnText='Product Mockups' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                  <Button btnLink='/service/service-details' btnText='Infographics & Data Visualization' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
               <Button btnLink='/service/service-details' btnText='Lowerthird, title, overlays' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
               <Button btnLink='/service/service-details' btnText='Platform Optimization' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
               <Button btnLink='/service/service-details' btnText='Series development' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                 <Button btnLink='/service/service-details' btnText='Audience Targetting' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>

              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80'/>
      <TestimonialSlider />
      <Spacing lg='145' md='80'/>
      <Div className="container cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-5 col-lg-6">
              <SectionHeading
                title='Some pre questions and answers' 
                subtitle='FAQ’s'
              />
              <Spacing lg='90' md='45'/>
            </Div>
            <Div className="col-lg-6 offset-xl-1">
              <Accordion/>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Cta 
          title='Let’s discuss and make <br />something <i>cool</i> together' 
          btnText='Apply For Meeting' 
          btnLink='/contact' 
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
